import { apiGet } from '../../api'

export const get_curriculum = query => {
  return apiGet({
    endpoint: `curriculums/get_curriculum${query}`
  })
}
